import type { LogEntry } from "@/game/types";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";

export function GameLog({ log }: { log: LogEntry[] }) {
  return (
    <div className="rounded-md border bg-background/60">
      <div className="border-b px-3 py-2 font-pixel text-[9px] uppercase tracking-wider text-muted-foreground">
        Trail Journal
      </div>
      <ScrollArea className="h-40">
        <ul className="space-y-1 p-3 font-terminal text-lg">
          {log.length === 0 && (
            <li className="text-muted-foreground">Nothing to report yet.</li>
          )}
          {log.map((entry) => (
            <li
              key={entry.id}
              className={cn(
                "leading-snug",
                entry.tone === "good" && "text-primary",
                entry.tone === "bad" && "text-destructive",
                entry.tone === "info" && "text-foreground/90",
              )}
            >
              <span className="text-muted-foreground">Day {entry.day}:</span>{" "}
              {entry.message}
            </li>
          ))}
        </ul>
      </ScrollArea>
    </div>
  );
}
